import { render, staticRenderFns } from "./comments-dialog.vue?vue&type=template&id=3b27c4b2&scoped=true"
import script from "./comments-dialog.vue?vue&type=script&lang=js"
export * from "./comments-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27c4b2",
  null
  
)

export default component.exports